import { Button, colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ButtonStyled = styled(Button)`
  width: 50%;
  min-width: auto;
  margin: 5rem auto 0;
`;

export const MessageStyled = styled.p`
  ${typography.regular[16]}
  margin: 3rem 0 0;
  color: ${colors.neutral[700]};
  text-align: center;
`;
